export default {
  page_title: '捐款人',
  curr: '現時的捐款人',
  past: '過去的捐款人',
  indi: '個人',
  firm: '律師行',
  intro: [
    'HKLII感謝以下人士和律師行的慷慨捐助，以支持 HKLII 提供免費法律資訊：',
  ],
  donation_page: '損款網頁',
  thanks: [
    'HKLII 感謝以上所有捐款人為 HKLII 的成功作出貢獻。如果您有興趣捐贈予 HKLII，請轉到我們的{0}。如果您有任何疑問，請按{1}。'
  ]
}